import { VariantProps } from 'class-variance-authority'
import { Link, LinkProps } from 'react-router-dom'
import { buttonVariants } from './button'
import Card from 'app/frontend/base/components/Card'
import { cn } from '@/lib/utils'

type Props = LinkProps & VariantProps<typeof buttonVariants>

const LinkButton = ({
  children,
  className,
  size,
  variant = 'outline',
  ...props
}: Props) => {
  return (
    <Link {...props}>
      <Card className={cn(buttonVariants({ variant, size }), className)}>
        {children}
      </Card>
    </Link>
  )
}

export default LinkButton
